import axios from "axios";
import { handleRequest } from "../../axios";
import { AUTH_SETUP_STATUS_URL, AUTH_SETUP_URL } from "../url";
import { API_SERVER_URL } from "../../../resources/constants";
import type { SetupRequest, SetupStatusResponse } from "../generated";

const backendURL = API_SERVER_URL;

// Axios instance for setup (without token interceptors - no auth exists yet)
const setupAxiosInstance = axios.create({
    baseURL: backendURL,
    withCredentials: true,
    timeout: 10000,
});

// -----------------------------
// SETUP METHODS
// -----------------------------

const getSetupStatus = () => {
    return handleRequest<SetupStatusResponse>(() =>
        setupAxiosInstance.get(AUTH_SETUP_STATUS_URL)
    );
};

const submitSetup = (data: SetupRequest) => {
    return handleRequest<void>(() =>
        setupAxiosInstance.post(AUTH_SETUP_URL, data)
    );
};

// -----------------------------

const SetupService = {
    getSetupStatus,
    submitSetup,
};

export default SetupService;
